'use strict'

/**
 * Archivo para configuracion de ruta de formulario de donaciones
 *
 * @author Valentin Agudelo Aquite
 * @version 1.0.0
 * @since 20/02/2020 8:41 AM.
 */

export default {
  path: 'frontoffice_page.pago_en_linea.route',
  component: () => import('../../components/layout/frontoffice/TheLayoutFrontoffice'),
  children: [
    {
      name: 'PagosEnLinea',
      path: '',
      component: () => import('../../components/view/frontoffice/public/pagosEnLinea/PagosEnLinea'),
      meta: {
        backoffice: false,
        requiresAuthentication: false,
        title: 'frontoffice_page.pago_en_linea.title'
      }
    }
  ]
}
